
    import { Component, Vue } from 'vue-property-decorator';
    //import API from '@/store/api';
    //import store from '@/store/auth';
    //import { mapMutations } from "vuex";

    @Component({
        data: () => {
            return {
                username: "",
                password: "",
            };
        },
        methods: {

            async login() {
                
                let url = process.env.VUE_APP_MYBASE_URL + '/auth/login'
                window.location.replace(url);
            },
        },
    })
    export default class Login extends Vue {

       

    }
